module.exports = __webpack_public_path__ + "design_work_icon.png?9740606855fac6908866cc1f78dfd870";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-icons/design_work_icon.png
// module id = 9
// module chunks = 0